export class Localizedstring
{
    constructor(  
        public name: string,
        public value: string,
        public resourceNotFound: boolean,
        public searchedLocation: string){
        }
}

export interface LocalizedHash{
    [name: string]: string; 
}

export function MapToLocalizedHash(items: Array<Localizedstring>):LocalizedHash{
    let localizedHash:LocalizedHash = {};
    items.forEach(r => localizedHash[r.name] = r.value);
    return localizedHash;
}